import React, { useState } from 'react';
import classnames from 'classnames';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './SecuredRepaymentList.module.scss';
import PageLink from 'components/PageLink/PageLink';

interface IDetail {
  label: string;
  value: string;
  isHtml?: boolean;
}

type Props = {
  Model?: any;
  PageData?: any;
  LayoutModel?: any;
};

const Detail = ({ label, value, isHtml }: IDetail) => (
  <div className={styles.detail}>
    <div className={styles.label}>{label}</div>
    {isHtml ? 
    (<div
      className={classnames(
        styles.value
      )}
      dangerouslySetInnerHTML={{ __html: value }}
    />) :
    (<div className={styles.value}>{value}</div>)}
    
  </div>
);

const SecuredRepaymentList = ({ Model, PageData }: Props) => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h2 className={styles.heading}>{PageData?.RepaymentPlanDetailsHeading}</h2>
          <Detail label={PageData?.PaymentsRemainingLabel} value={Model?.PaymentPlan?.InstalmentsRemainingText} />
        </header>

        <div
          className={classnames(
            styles.content,
            !showDetails ? styles.Paymentlist_mobile : '',
          )}
        >
          <div className={styles.row}>
            <Detail label={PageData?.RecentPaymentLabel} value={Model?.PaymentPlan?.LastPaymentAmountText} isHtml={true} />
            <Detail label={PageData?.RecentPaymentDateLabel} value={Model?.PaymentPlan?.LastPaymentDateText} />
            <Detail label={PageData?.NextPaymentDateLabel} value={Model?.PaymentPlan?.NextPaymentDateText} />
            
            <Detail label={PageData?.AgreedAmountLabel} value={Model?.PaymentPlan?.AgreedInstalmentAmountText} isHtml={true} />
            
            <Detail label={PageData?.PaymentsEndDateLabel} value={Model?.PaymentPlan?.PlanEndDateText} />
            <Detail label={PageData?.PaymentMethodLabel} value={Model?.PaymentPlan?.PaymentMethodText} />
            
          </div>
          {Model?.HasRightsToEditPaymentMethod &&
          (<div className={styles.PayButton}>
            <PageLink
              className={classnames(styles.button, 'Button Button--ghost')}
              url={Model?.DebtOverviewPanelViewModel?.EditLinkUrl}
              text={PageData?.UpdatePaymentMethodSecuredButtonText}
            />              
          </div>)
          }
        </div>
        <div className={styles.Paymentlist_mobilebtn}>
          <button
            className={classnames(
              styles.toggleBtn,
              showDetails && styles.expanded,
            )}
            onClick={() => setShowDetails(!showDetails)}
          >            
            {showDetails ? PageData?.HidePlanDetailsLabel : PageData?.ShowPlanDetailsLabel}
            <Icon
              type={SvgIcons.CHEVRON_ICON}
              width={14}
              height={14}
              className={classnames(
                styles.expandIcon,
                showDetails && styles.expanded,
              )}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default SecuredRepaymentList;
